import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import SurveyKPI from "../../ui/surveyKPI";
import Widget from "../../ui/widget";
import WidgetSkeleton from "../../ui/widgetSkeleton";
import WidgetSurveyContent from "../../ui/widgetSurveyContent";
import WidgetTitle from "../../ui/widgetTitle";

const EmpireStoplight = props => {
  const { userKPIs } = props;

  const [rows, setRows] = useState(null);

  useEffect(() => {
    setRows(null);
    setLocalKPIs(userKPIs);
  }, [userKPIs]);

  const [localKPIs, setLocalKPIs] = useState(null);

  useEffect(() => {
    if (localKPIs != null && rows == null) {
      setRows(localKPIs);
    }
  }, [localKPIs, rows]);

  return (
    <Widget>
      <WidgetTitle title={"Report"} text={"Stoplight"} loading={false}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyKPI kpiODMs={rows} />
        </WidgetSurveyContent>
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  userKPIs: state.userSession.userKPIs,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EmpireStoplight);
